export default __webpack_public_path__ + "static/media/trello_lists.69d3bb28.png";